import React from "react";

const ResultListOffer = ({ result, searchAttributes }) => {
  let price;
  let priceComplement;
  let priceBefore;

  if (result.offer.price_value) {
    price = result.offer.price_formatted;

    if (result.offer.from_price) {
      priceBefore = <span className="price-info">à partir de </span>;
    } else if (searchAttributes && searchAttributes.nights > 1) {
      priceComplement = <span className="price-info">/nuit</span>;
    }
  } else {
    priceComplement = <span className="price-info">Prix non communiqué</span>;
  }

  const availabilitiesUrl = `${result.hotel.url}#availabilities`;

  return (
    <div
      className="mobile-container "
      itemProp="makesOffer"
      itemScope
      itemType="https://schema.org/AggregateOffer"
    >
      <div className="mobile-info-container">
        <p className="price">
          {priceBefore}
          <span itemProp="lowPrice">{price}</span>
          <meta itemProp="priceCurrency" content="EUR" />
          {priceComplement}
        </p>
      </div>
      <div className="mobile-button-container">
        <a href={availabilitiesUrl} className="button-standard" rel="external">
          voir les offres
        </a>
      </div>
    </div>
  );
};
export default ResultListOffer;
